import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductState } from '@/shared/api/protocol-ts/api/billing_new/dto_product_new_pb';
import { Button } from '@/shared/ui';

import { InventoryItemView } from '@/features/inventoryItemView';
import { ProductStatus } from '@/features/inventoryItemView/config/types';

import { BillingPeriod } from '../BillingPeriod/BillingPeriod';
import { PaymentReminder } from '../PaymentReminder/PaymentReminder';

import styles from './SubscriptionCard.module.scss';

type SubscriptionCardProps = {
  title: string;
  className?: string;
  children?: ReactNode;
  createdAt?: Date;
  overrideStatus?: ProductStatus;
  showPaymentReminder?: boolean;
  subscription?: ProductState;
  testID?: string;
  onOpenShop?: () => void;
};

export const SubscriptionCard: FC<SubscriptionCardProps> = (props) => {
  const {
    className,
    children,
    createdAt,
    onOpenShop,
    overrideStatus,
    showPaymentReminder = true,
    subscription,
    testID,
    title,
  } = props;

  const startDate = subscription?.Start?.toDate();
  const endDate = subscription?.End?.toDate();

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="current-subscription-card"
    >
      <header className={styles.header}>
        <h4 className="h4">{title}</h4>

        {onOpenShop && (
          <Button variant="secondary" onClick={onOpenShop}>
            <FormattedMessage
              id="subscription.viewPlans"
              defaultMessage="View plans"
            />
          </Button>
        )}
      </header>

      {subscription ? (
        <>
          <InventoryItemView
            className={styles.inventoryItem}
            inventoryItem={subscription}
            overrideStatus={overrideStatus}
          />

          {startDate && endDate && (
            <BillingPeriod
              createdAt={createdAt}
              endDate={endDate}
              startDate={startDate}
            />
          )}

          {showPaymentReminder && <PaymentReminder />}

          {children}
        </>
      ) : (
        children
      )}
    </div>
  );
};
